import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter015() {
  return <KbChapterPage slug="chapter-015" />;
}

(Chapter015 as unknown as { path: string }).path = "/theory-album/015";
